import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return routerPush.call(this, location, onResolve, onReject)
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return routerReplace.call(this, location, onResolve, onReject)
  return routerReplace.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'hash',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/',
      name: 'index',
      component: resolve => require(['../views/home/index'], resolve)
    }]
  },
  {
    path: '/home',
    name: 'home',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [
      {
        path: '/artcile/detail/:id',
        name: 'artcileDetail',
        meta: {
          pageName: '文章详情'
        },
        component: resolve => require(['../views/home/artcileDetail'], resolve)
      },
      // {
      //   path: '/case',
      //   name: 'case',
      //   meta: {
      //     pageName: '标准案例'
      //   },
      //   component: resolve => require(['../components/page/index/case.vue'], resolve)
      // },
      {
        path: '/case/detail/:id',
        name: 'caseDetail',
        meta: {
          pageName: '案例详情'
        },
        component: resolve => require(['../views/home/caseDetail.vue'], resolve)
      },
      {
        path: '/commercial/detail/:id',
        name: 'commercialDetail',
        meta: {
          pageName: '业态详情'
        },
        component: resolve => require(['../views/home/commercialDetail.vue'], resolve)
      },
      {
        path: '/store',
        name: 'store',
        meta: {
          pageName: '应用商店'
        },
        component: resolve => require(['../components/page/index/store.vue'], resolve)
      },
      {
        path: '/detail/:id/:type',
        name: 'detail',
        meta: {
          pageName: '应用详情'
        },
        component: resolve => require(['../components/page/index/detail.vue'], resolve)
      },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        meta: {
          pageName: '个人中心'
        },
        component: resolve => require(['../components/page/index/personalCenter.vue'], resolve)
      },
      {
        path: '/search/:name?',
        name: 'search',
        meta: {
          pageName: '搜索结果'
        },
        component: resolve => require(['../views/home/search'], resolve)
      }
    ]
  },
  {
    path: '/application',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/application/list/:categoryId',
      name: 'applicationList',
      meta: {
        pageName: '应用列表'
      },
      component: resolve => require(['../views/application/list'], resolve)
    },
    {
      path: '/application/detail/:id',
      name: 'applicationDetail',
      meta: {
        pageName: '应用详情'
      },
      component: resolve => require(['../views/application/detail'], resolve)
    },
    {
      path: '/application/solutiondetail',
      name: 'applicationSolutiondetail',
      meta: {
        pageName: '解决方案详情'
      },
      component: resolve => require(['../views/application/solutiondetail'], resolve)
    },
    {
      path: '/application/myApplication',
      name: 'myApplication',
      meta: {
        pageName: '我的应用'
      },
      component: resolve => require(['../views/application/myApplication'], resolve)
    },
    {
      path: '/application/course/:courseId',
      name: 'course',
      meta: {
        pageName: '使用教程'
      },
      component: resolve => require(['../views/application/course'], resolve)
    }
    ]
  },
  {
    path: '/taizhou',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/taizhou',
      name: 'taizhou',
      meta: {
        pageName: '台州专区'
      },
      component: resolve => require(['../views/taizhou/index'], resolve)
    }
    ]
  },
  {
    path: '/huangyan',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/huangyan',
      name: 'huangyan',
      meta: {
        pageName: '黄岩专区'
      },
      component: resolve => require(['../views/huangyan/index'], resolve)
    }
    ]
  },
  {
    path: '/yiwu',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/yiwu',
      name: 'yiwu',
      meta: {
        pageName: '义乌专区'
      },
      component: resolve => require(['../views/taizhou/index'], resolve)
    }
    ]
  },
  {
    path: '/haishu',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/haishu',
      name: 'haishu',
      meta: {
        pageName: '海曙专区'
      },
      component: resolve => require(['../views/haishu/index'], resolve)
    }
    ]
  },
  {
    path: '/case',
    component: resolve => require(['../components/common/Home.vue'], resolve),
    children: [{
      path: '/case/list',
      name: 'caseList',
      meta: {
        pageName: '案例列表'
      },
      component: resolve => require(['../views/case/list'], resolve)
    },
    {
      path: '/case/info/:id',
      name: 'caseDetail',
      meta: {
        pageName: '案例详情'
      },
      component: resolve => require(['../views/case/detail'], resolve)
    }
    ]
  },
  {
    path: '/authorize',
    component: resolve => require(['../components/page/authorize.vue'], resolve)
  },
  {
    path: '/404',
    name: 'notFound',
    component: resolve => require(['../components/page/404.vue'], resolve)
  }, {
    path: '*',
    redirect: '/404'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js